import {z} from 'zod';

import {driverInformationSchema} from './driverInformationSchema';

export const orderInternalFormSchema = (isFieldRequired: (name: string) => boolean) =>
  z
    .object({
      completionAtDate: isFieldRequired('completionAtDate') ? z.date() : z.date().nullish(),
      completionAtTime: isFieldRequired('completionAtTime') ? z.string() : z.string().nullish(),
      totalPriceEstimated: isFieldRequired('totalPriceEstimated')
        ? z.number()
        : z.number().nullish(),
      note: z.string().nullish(),
      costCenter: isFieldRequired('costCenter') ? z.string() : z.string().nullish(),
      mileage: isFieldRequired('mileage') ? z.number().min(0) : z.number().min(0).nullish(),
      fuelTank: isFieldRequired('fuelTank') ? z.number() : z.number().nullish(),
      returnUsedParts: z.boolean().nullish(),
      serviceOrderGroupId: isFieldRequired('serviceOrderGroupId')
        ? z.string()
        : z.string().nullish(),
      serviceCenterId: isFieldRequired('serviceCenterId') ? z.string() : z.string().nullish(),
      cancelReason: z.string().nullish(),
      email: z.string().nullish(),
      phone: z.string().nullish(),
    })
    .merge(driverInformationSchema);

export type OrderInternalFormType = z.infer<ReturnType<typeof orderInternalFormSchema>>;
